// calcPathCenterCoords is now pre-computed in Map.php

// External (area) locations come from the AI's Google Places lookup, where a
// result can lack geometry — leaving lat/lng null or undefined. Feeding those
// into google.maps.LatLng yields NaN, which corrupts fitBounds/setZoom and
// blanks the map (throws "uint32"). Only keep locations with finite coords.
export function isValidExternalLocation(loc) {
  if (!loc) return false;
  const { lat, lng } = loc;
  // Reject null/undefined/empty before Number() — Number(null) and Number('')
  // both coerce to 0, which would slip a bogus (0,0) location through.
  if (lat == null || lng == null || lat === '' || lng === '') return false;
  return Number.isFinite(Number(lat)) && Number.isFinite(Number(lng));
}

export function getUnitDisplayMode(
  matchingUnitData,
  activeLevelOfCareUuid,
  mapActiveUnitData,
) {
  let displayMode = 'disabled';

  // Does this unit match any of the filter results?
  const isActive = mapActiveUnitData.hasOwnProperty(matchingUnitData.svgId);

  const unitLevelofCareUuid = matchingUnitData.levelOfCareUuid
    ? matchingUnitData.levelOfCareUuid
    : null;
  const matchesLevelOfCare = unitLevelofCareUuid === activeLevelOfCareUuid;

  switch (true) {
    case matchesLevelOfCare && isActive:
      displayMode = 'active';
      break;
    case matchesLevelOfCare:
      displayMode = 'inactive';
      break;
    case !matchesLevelOfCare:
      displayMode = 'disabled';
      break;
    default:
      break;
  }

  return displayMode;
}

export function findParentLevelId(targetId, obj, currentLevelId = null) {
  if (!obj || typeof obj !== 'object') return null;
  for (const key in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
    const value = obj[key];
    // If this key is a level (e.g., "level1", "level2"), update currentLevelId
    let newLevelId = currentLevelId;
    if (/^level\d+$/i.test(key)) {
      newLevelId = key;
    }
    if (key === targetId) {
      // Return the most recent level id in the hierarchy
      return newLevelId;
    }
    if (typeof value === 'object' && value !== null) {
      const found = findParentLevelId(targetId, value, newLevelId);
      if (found) return found;
    }
  }
  return null;
}
